import type { Doc } from "building-types/doc";
import type {
  BuildingGeometry,
  BuildingGeometryEmitter,
  BuildingProp,
} from "building-types/geometry/buildingGeometryTypes";
import { getReportableUnitDesignatorLabelIds } from "doc/utils/labelTools";
import { reportingUnitLabelFromEntityId } from "doc/utils/reportingUnitDocTools";

function resolveReportingUnitLabelId(
  doc: Doc,
  reportingUnitLabelIds: readonly string[],
  item: BuildingGeometry | BuildingProp,
): string | undefined {
  return (
    item.reportingUnitLabelId ??
    reportingUnitLabelFromEntityId(doc, reportingUnitLabelIds, item.entityHandleForSelectingReportingUnit)
  );
}

export function createReportingUnitResolvingEmitter(
  doc: Doc,
  baseEmitter: BuildingGeometryEmitter,
): BuildingGeometryEmitter {
  const reportingUnitLabelIds = getReportableUnitDesignatorLabelIds(doc);
  if (reportingUnitLabelIds.length === 0) {
    return baseEmitter;
  }

  return {
    emit: (geometry: BuildingGeometry): void => {
      baseEmitter.emit({
        ...geometry,
        reportingUnitLabelId: resolveReportingUnitLabelId(doc, reportingUnitLabelIds, geometry),
      });
    },
    emitProp: baseEmitter.emitProp
      ? (prop: BuildingProp): void => {
          baseEmitter.emitProp?.({
            ...prop,
            reportingUnitLabelId: resolveReportingUnitLabelId(doc, reportingUnitLabelIds, prop),
          });
        }
      : undefined,
    beginGroup: baseEmitter.beginGroup?.bind(baseEmitter),
    endGroup: baseEmitter.endGroup?.bind(baseEmitter),
  };
}
